export default __webpack_public_path__ + "static/media/B03.3fefdb69.png";